import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";

type State = {
  IdProcesso: number;
  pesquisa: string | null,

};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setPesquisa: SetFunction<string | null>,
};


export const initialFiltersValues: State = {
  IdProcesso: 0,
  pesquisa: "",
};

export const useProcessosRiscosFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setPesquisa: (vfn) => SetFunctionImpl(set, 'pesquisa', vfn),
  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set(initialFiltersValues),

}));